<div class="description bedrock">
  <div class="model-response">
    <markdown [data]="reconstitutedText()" [disableSanitizer]="true"> </markdown>
  </div>
</div>

@if (showPreview()) {
  <div class="video-container">
    <app-smart-fix-video-preview [messageText]="reconstitutedText()"></app-smart-fix-video-preview>
  </div>
}
